import { graphql } from "gatsby"
import { gql } from "@apollo/client"

export const query = graphql`
  fragment entrySEO on Craft_SeomaticType {
    metaTitleContainer
    metaTagContainer
    metaJsonLdContainer
    metaLinkContainer
    metaScriptContainer
    metaSiteVarsContainer
    remoteTypeName
  }
`

export const entrySEO = gql`
  fragment entrySEO on SeomaticType {
    metaTitleContainer
    metaTagContainer
    metaJsonLdContainer
    metaLinkContainer
    metaScriptContainer
    metaSiteVarsContainer
  }
`
